import type { DocumentCategory } from '../hooks/useDocuments';
import type { MessageKey } from '../i18n/messages';

/**
 * Customer-facing Documents sections, in display order (owner spec 2026-09-20).
 * `value` is the `document_category` enum label the row is stored under;
 * `key` is the i18n label; `hintKey` is an optional tooltip / subtitle.
 *
 * Storage values that are not sections (network_diagram, floor_plan, as_built,
 * certificate, contract, invoice, proposal, other) remain valid and are only
 * reachable through the "All" filter.
 */
export interface DocumentSection {
  value: DocumentCategory;
  key: MessageKey;
  hintKey?: MessageKey;
}

export const DOCUMENT_SECTIONS: readonly DocumentSection[] = [
  { value: 'kb', key: 'documents.category.kb' },
  { value: 'photo', key: 'documents.category.photo' },
  { value: 'ipam', key: 'documents.category.ipam', hintKey: 'documents.category.ipam_hint' },
  { value: 'rack_elevation', key: 'documents.category.rack_elevation' },
  { value: 'website', key: 'documents.category.website' },
  { value: 'expiration', key: 'documents.category.expiration' },
  { value: 'application', key: 'documents.category.application' },
  { value: 'computer_asset', key: 'documents.category.computer_asset' },
  { value: 'location', key: 'documents.category.location' },
  { value: 'network_device', key: 'documents.category.network_device' },
  { value: 'person', key: 'documents.category.person' },
  { value: 'vendor', key: 'documents.category.vendor' },
  { value: 'wireless', key: 'documents.category.wireless' },
  { value: 'carrier_wan', key: 'documents.category.carrier_wan' },
  { value: 'telephony', key: 'documents.category.telephony' },
] as const;
